module.exports = __webpack_public_path__ + "static/thumb_up_wechat-82098809d9d44084b677b538277d9621.jpg";